import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import ClaimsStatusLayout from "./components/ClaimsStatusLayout";
import ClaimsStatus from "./pages/ClaimsStatus";
import ClaimDetail from "./pages/ClaimDetail";
import FileClaim from "./pages/FileClaim";

function App() {
  return (
    <div className="App">
      <Toaster 
        position="top-right" 
        richColors 
        toastOptions={{
          style: {
            fontFamily: 'Plus Jakarta Sans, sans-serif',
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ClaimsStatusLayout />}>
            <Route index element={<ClaimsStatus />} />
            <Route path="file-claim" element={<FileClaim />} />
            <Route path="claims/:claimId" element={<ClaimDetail />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
